module.exports = __webpack_public_path__ + "imgs/0490971dc8a28391a69f114755298dac.jpg";